/* eslint-disable import/no-cycle */
import React, {useState} from 'react';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'react-i18next';
import {Alert, Divider} from 'antd';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useMount} from '../../hooks/useMount';
import {WidgetLayout} from '../../models/widgetLayout';
import OperatorWidget from '../operator/shared/OperatorWidget';
import {WidgetLayouts} from '../shared/widgets/WidgetLayouts';
import {useStore} from '../../hooks/useStore';
import {ScopeContext} from '../../policies/scopeContext';
import {materialManagement, processdataCollection} from '../../models/scope';
import {useModulePolicy} from '../../hooks/useModulePolicy';
import {SensorData as Model} from '../../models/sensorData';
import {ManualSenensorDataWidgetConfig} from './manualSenensorDataWidgetConfig';
import {ManualSensorDataWidgetModal} from './ManualSensorDataWidgetModal';
import Button from '../shared/buttons/Button';

const ManualSensorDataWidget = ({disabled, identifier}) => {
  const {t} = useTranslation();
  const store = useStore();
  const [newModalVisible, setNewModalVisible] = useState(false);
  const [missingActiveOperation, setMissingActiveOperation] = useState(false);
  const widgetConfig = new ManualSenensorDataWidgetConfig(store, ManualSensorDataWidget.identifier);
  const policy = useModulePolicy(store, [materialManagement]);

  useMount(() => {
    store.sensorStore.loadAll({
      params: {
        isManual: true,
      },
    });
  });

  useMount(() => {
    setMissingActiveOperation(widgetConfig.getIncludeOrderId() && !store.operationStore.active);
  }, [widgetConfig.getIncludeOrderId(), store.operationStore.active?.id]);

  const ConfigAlert = ({message}) => (<Alert type={'warning'} message={message}/>);

  const sensor = store.sensorStore.getById(widgetConfig.getSensorName());
  const missingConfig = !sensor;

  return (
    <ScopeContext.Provider value={[processdataCollection]}>
      <OperatorWidget
        disabled={disabled}
        icon={<FontAwesomeIcon icon={Model.faIcon}/>}
        title={widgetConfig.getWidgetTitle()}
        identifier={identifier}
        widgetConfig={widgetConfig}
      >
        {missingConfig && (
          <ConfigAlert message={t('manualSensorDataWidget.missingConfig')}/>
        )}

        {missingActiveOperation && (
          <ConfigAlert message={t('manualSensorDataWidget.noActiveOperation')}/>
        )}

        {!missingConfig && !missingActiveOperation && (
          <Button
            type={'primary'}
            onClick={() => setNewModalVisible(true)}
            size={'large'}
            block
            disabled={!policy.canCreate()}
          >
            {t('manualSensorDataWidget.create')}
          </Button>
        )}
        {sensor && (
          <Divider>
            {sensor.label}
          </Divider>
        )}
      </OperatorWidget>

      {newModalVisible && (
        <ManualSensorDataWidgetModal
          widgetConfig={widgetConfig}
          onCancel={() => {
            setNewModalVisible(false);
          }}
          onSuccess={() => {
            setNewModalVisible(false);
          }}
          sensor={sensor}
        />
      )}
    </ScopeContext.Provider>
  );
};

ManualSensorDataWidget.identifier = 'ManualSensorDataWidget';
ManualSensorDataWidget.defaultLayout = new WidgetLayout(
  {
    identifier: ManualSensorDataWidget.identifier,
    x: 0,
    y: 16,
    height: 3,
    minHeight: 3,
    width: WidgetLayouts.sixthWidth.w,
    minWidth: WidgetLayouts.sixthWidth.minW,
    disabled: true,
  }
);
export default observer(ManualSensorDataWidget);
